import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { loginSuccess, apiError, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(axios.post, "/security/user/login", {
      email: user.email,
      password: user.password,
    });
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      let responseData = response.data.data;

      // Set Axios Default Header
      axios.defaults.headers.common["Authorization"] =
        responseData.Authorization;

      // Set Profile Picture (prevent cache)
      responseData.user.url_avatar = responseData.user.url_avatar
        ? responseData.user.url_avatar + "?time=" + new Date().getTime()
        : null;

      // Set localStorage authUser
      localStorage.setItem("authUser", JSON.stringify(responseData));

      yield put(loginSuccess(responseData));
      history.push("/dashboard");
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* logoutUser({ payload: { history, isExpired = false } }) {
  localStorage.removeItem("authUser");
  if (isExpired === false) {
    try {
      const response = yield call(axios.post, "/user/logout");
      if (
        !(
          (response.status >= 200 || response.status <= 299) &&
          response.data &&
          response.data.data
        )
      ) {
        throw response.data;
      }
    } catch (error) {
      console.error(error);
    } finally {
      yield put(logoutUserSuccess());
      if (history) history.push("/login");
    }
  }
}

export function* watchUserLogin() {
  yield takeEvery(LOGIN_USER, loginUser);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}

function* authSaga() {
  yield all([fork(watchUserLogin), fork(watchUserLogout)]);
}

export default authSaga;
